import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  TablePagination,
  Divider,
  Checkbox,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import parse from "html-react-parser";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CheckIcon from "@mui/icons-material/Check";
import MainCard from "../../../components/Maincard";
import CustomPopup from "../../../components/CustomPopup";
import AddTemplateForm from "./AddTemplateForm";
import EditIcon from "@mui/icons-material/Edit";
import EditTemplateForm from "./EditTemplateForm";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useGetTokenOrLogout } from "../../../utils/token";
import { useNavigate } from "react-router-dom";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import ApplyFilterButton from "../../newComponent/NewButtonComp/ApplyFilterButton";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import SearchButton from "../../newComponent/NewButtonComp/SearchButton";
import ResetFilterButton from "../../newComponent/NewButtonComp/ResetFilterButton";
import ResetButtonComp from "../../newComponent/NewButtonComp/ResetButtonComp";
import ClearButtonComp from "../../newComponent/NewButtonComp/ResetButtonComp";
import EmailData from "./EmailData";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import NoEnquiry from "../../components/DataTransferComp.jsx/NoEnquiry";
import AcceptConfirmationPopup from "../RecycleRequest/AcceptConfirmationPopup";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
const PATH_URL = process.env.REACT_APP_API_UPLOADS;
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function Tamplate() {
  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const [templatelist, setTemplatelist] = useState([]);
  const [templateTitle, setTemplateTitle] = useState("");
  const [loader, setLoader] = useState(false);
  const [openRow, setOpenRow] = useState(null);
  const [openViewTemplate, setOpenViewTemplate] =useState(false)
  const [addTemplatePopup, setAddtemplatePopup] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [originalData, setOriginaldata] = useState([]);
  const [editopenpopup, setEditOpenpopup] = useState(false);
  const [selecteddata, setSelecteddata] = useState(null);
  const [selectedTemplateIds, setSelectedTemplateIds] = useState([]);
  const [openAccept, setOpenAccept] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  
    const showSnackbar = (message, severity) => {
      setSnackbarMessage(message);
      setSnackbarSeverity(severity);
      setSnackbarOpen(true);
    };

  const handleOpenPopup = () => {
    setAddtemplatePopup(true);
  };

  const handleclosePopup = () => {
    setAddtemplatePopup(false);
  };

  const handleOpenEditPopup = (data) => {
    setEditOpenpopup(true);
    setSelecteddata(data);
  };

  const handlecloseEditPopup = () => {
    setEditOpenpopup(false);
  };

  const handleOpenAcceptPopup = () => {
    setOpenAccept(true)
  }

  const handleCloseAcceptPopup = () => {
    setOpenAccept(false)
  }

  useEffect(() => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const fetchData = async () => {
      try {
        setLoader(true);
        const response = await fetch(`${API_ENDPOINT}route/fetchtemplate`, {
          headers,
        });
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setTemplatelist(sortedData);
          console.log(sortedData);
          setOriginaldata(sortedData);
          setLoader(false);
        } else if (response.status === 404) {
          navigate("/page404");
        } else if (response.status === 401) {
          navigate("/page401");
        } else if (response.status === 403) {
          navigate("/page403");
        } else if (response.status === 440) {
          navigate("/page440");
        } else {
          navigate("/page500");
        }
      } catch {
        navigate("/page500");
      }
    };

    fetchData();
  }, []);

  const handleSearch = () => {
    const filtered = originalData.filter((template) =>
      template.template_title
        .toLowerCase()
        .includes(templateTitle.toLowerCase())
    );
    setTemplatelist(filtered);
  };

  const handlereset = () => {
    setTemplateTitle("");
    setTemplatelist(originalData);
  };

  // const toggleRow = (index) => {
  //   setOpenRow((prevOpenRow) => (prevOpenRow === index ? null : index));
  // };
  const openEmailPopup=(data)=>{
    setOpenViewTemplate(true)
    setSelecteddata(data)

  }
   const CloseViewEmailPopup=()=>{
    setOpenViewTemplate(false)
   }

    const handleDeleteTemplate = () => {
      const token = getTokenOrLogout();
      if (!token) return;
      let headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const formdata = {
        user_id: parseInt(userId),
        template_id: selectedTemplateIds
      };

    fetch(`${API_ENDPOINT}emailtemplate/deletetemplate`, {
      method: "POST",
      headers,
      body: JSON.stringify(formdata),
    })
      .then((response) => {
        if (response.ok) {
          showSnackbar("Template(s) Deleted Successfully.");
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          console.error("Error: Unknown Error");
          showSnackbar("Error: Unknown Error", "error");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        showSnackbar("Error: Unknown Error", "error");
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, templatelist.length - page * rowsPerPage);

    const handleSelectRow = (id) => {
      setSelectedTemplateIds(prev =>
        prev.includes(id)
          ? prev.filter(x => x !== id)
          : [...prev, id]
      );
    };

    const handleSelectAll = (checked) => {
      if (checked) {
        setSelectedTemplateIds(templatelist.map(t => t.id));
      } else {
        setSelectedTemplateIds([]);
      }
    };

    const handleSingleDelete = (id) => {
      setSelectedTemplateIds([id]);  
      setOpenAccept(true);
    };

    const handleDeleteMultiple = () => {
      setOpenAccept(true);
    };


  return (
    <>
      <Backdrop open={loader} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Fetching
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>
      <Grid container mb={2} spacing={2}>
        <Grid item xs={12} lg={2} sm={3} md={2.5}>
          <HeadingCard label="Email Template" />
        </Grid>
        <Grid item xs={12} sm={9} md={9.5} lg={10} textAlign="end">
          <ApplyFilterButton
            addbutton={true}
            onClick={handleOpenPopup}
            label="Add Template"
          />
          <Button
            startIcon={<DeleteOutlineOutlinedIcon fontSize='small'/>}
            onClick={handleDeleteMultiple}
            variant="contained"
            size="small"
            style={{borderRadius:'7px', background:"red", marginLeft: "10px"}}
          >Delete Template</Button>
        </Grid>
        <Grid item xs={12} lg={12} md={12} sm={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={6} sm={6} md={6}>
                <Typography variant="h5">Search By Template Title</Typography>
                <TextField
                  size="small"
                  fullWidth
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                  value={templateTitle}
                  onChange={(e) => setTemplateTitle(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} md={6} sm={6} lg={6} container>
                <Typography
                  variant="h5"
                  sx={{
                    visibility: "hidden",
                  }}
                >
                  Search By Template Title
                </Typography>
                <Grid container gap={1}>
                  <SearchButton onClick={handleSearch} />

                  <ClearButtonComp onClick={handlereset} />
                </Grid>
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <Grid item xs={12} lg={12} md={12} sm={12}>
        <MainCard>
          <TableContainer component={Paper}>
            <Table
              aria-label="simple table"
              sx={{ border: "1px solid rgba(224, 224, 224, 1)" }}
            >
              <TableHead>
                <TableRow sx={{ height: "10px" }}>
                  <TableCell
                    sx={{
                      background: "#E1EBEE",
                      padding: "10px",
                      width: "40px",
                    }}
                  >
                    <Checkbox
                      size="small"
                      checked={selectedTemplateIds.length === templatelist.length}
                      indeterminate={
                        selectedTemplateIds.length > 0 &&
                        selectedTemplateIds.length < templatelist.length
                      }
                      onChange={(e) => handleSelectAll(e.target.checked)}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      background: "#E1EBEE",
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                      padding: "10px",
                      lineHeight: "1",
                      verticalAlign: "top",
                      fontWeight: 600,
                      fontSize: "0.7rem",
                    }}
                  >
                    Template Name
                  </TableCell>
                  <TableCell
                    sx={{
                      background: "#E1EBEE",
                      height: "10px",
                      padding: "10px",
                      lineHeight: "1",
                      verticalAlign: "top",
                      textAlign: "center",
                      fontWeight: 600,
                      fontSize: "0.7rem",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!loader && templatelist.length === 0 ? (
                  <Typography>No data</Typography>
                ) : (
                  (rowsPerPage > 0
                    ? templatelist.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                    : templatelist
                  ).map((item, index) => (
                    <React.Fragment key={item.id}>
                      <TableRow>
                         <TableCell
                          sx={{
                            borderBottom: "1px solid rgba(224, 224, 224, 1)",
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            fontSize: "0.7rem",
                            padding: "10px",
                            lineHeight: "1",
                          }}
                         >
                        <Checkbox
                          size="small"
                          checked={selectedTemplateIds.includes(item.id)}
                          onChange={() => handleSelectRow(item.id)}
                        />
                      </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: "1px solid rgba(224, 224, 224, 1)",
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            fontSize: "0.7rem",
                            padding: "10px",
                            lineHeight: "1",
                          }}
                        >
                          {item.template_title}
                        </TableCell>

                      <TableCell
                      sx={{
                        borderBottom: "1px solid rgba(224, 224, 224, 1)",
                        padding: "10px",
                        lineHeight: "1",
                        textAlign: "center",     
                        verticalAlign: "middle", 
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          onClick={() => openEmailPopup(item)}
                          sx={{
                            height: "15px",
                            width: "18px",
                            borderRadius: "40%",
                            background: "blue",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          <RemoveRedEyeOutlinedIcon fontSize="small" style={{ fontSize: "0.8rem" }} />
                        </Box>

                        <Box
                          onClick={() => handleOpenEditPopup(item)}
                          sx={{
                            height: "15px",
                            width: "18px",
                            borderRadius: "40%",
                            background: "green",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <EditIcon fontSize="small" style={{ fontSize: "0.8rem" }} />
                        </Box>

                        <Box
                          onClick={() => handleSingleDelete(item.id)}
                          sx={{
                            height: "15px",
                            width: "18px",
                            borderRadius: "40%",
                            background: "red",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <DeleteOutlineOutlinedIcon fontSize="small" style={{ fontSize: "0.8rem" }} />
                        </Box>
                      </Box>
                    </TableCell>

                      </TableRow>
                    </React.Fragment>
                  ))
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={templatelist.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </MainCard>
      </Grid>

      <CustomPopup
        open={addTemplatePopup}
        onClose={handleclosePopup}
        component={<AddTemplateForm onClose={handleclosePopup} />}
        title="Add Template"
        maxWidth="sm"
        showDivider={true}
      />

      <CustomPopup
        open={editopenpopup}
        onClose={handlecloseEditPopup}
        component={
          <EditTemplateForm
            onClose={handlecloseEditPopup}
            selecteddata={selecteddata}
            setTemplatelist={setTemplatelist}
          />
        }
        title="Edit Template"
        maxWidth="sm"
        showDivider={true}
      />
       <CustomPopup
              open={openViewTemplate}
              onClose={CloseViewEmailPopup}
              component={
                <EmailData
                  onClose={CloseViewEmailPopup}
                  data={selecteddata}
                />
              }
              title="Template Details"
              showDivider="true"
              maxWidth="sm"
            />

          {selectedTemplateIds.length === 0 ? (
              <CustomPopup
                open={openAccept}
                onClose={handleCloseAcceptPopup}
                component={
                  <NoEnquiry onClose={handleCloseAcceptPopup} text="deleting" title="No Template" />
                }
                maxWidth="xs"
              />
            ) : (
                  <AcceptConfirmationPopup
                  open={openAccept}
                  onClose={handleCloseAcceptPopup}
                  title="Confirmation"
                  component=""
                  maxWidth="xs"
                  showDivider={true}
                  textBody="Are you sure you want to delete the selected email template(s) ?"
                  handleUpdateStatus={handleDeleteTemplate}
                  selectedId={selectedTemplateIds}
                  />
            )}
           <CustomSnackbar
                  open={snackbarOpen}
                  onClose={() => setSnackbarOpen(false)}
                  message={snackbarMessage}
                  severity={snackbarSeverity}
            />
    </>
  );
}
